import {Map, fromJS} from 'immutable'

import {
  SET_USER_SESSION_REFS,
  REMOVE_USER_SESSION_REF,
  SET_USER_SESSIONS,
  SET_USER_SESSIONS_COUNT,
  SET_SESSION,
  SET_SESSIONS,
  SET_CURRENT_SESSION,
  SET_SESSION_ACTIVITY,
  SET_SESSION_REQUEST,
  SET_SESSION_REQUESTS,
  SET_SESSION_CLAIMS
} from '../action_types'

import sessionRefsReducer from './session_refs'

export default (state = Map({}), action) => {
  switch (action.type) {
    case SET_USER_SESSION_REFS:
      return state.set(
        '_refs',
        sessionRefsReducer(state.get('_refs'), action)
      )

    case REMOVE_USER_SESSION_REF:
      return state.set(
        '_refs',
        sessionRefsReducer(state.get('_refs'), action)
      )

    case SET_USER_SESSIONS:
      if (action.sessions == null) {
        return state.set('experts', action.sessions)
      }
      else {
        return state.mergeDeep({experts: action.sessions})
      }

    case SET_USER_SESSIONS_COUNT:
      return state.mergeDeep({_counts: {[action.uid]: action.count}})

    case SET_SESSION:
      return state.mergeDeep({experts: {[action.key]: action.session}})

    case SET_SESSIONS:
      return state.set('experts', fromJS(action.sessions))

    case SET_CURRENT_SESSION:
      return state.set('_current', action.sessionId)

    case SET_SESSION_ACTIVITY:
      if (action.sessionActivity && action.sessionId) {
        return state.mergeDeep({_activities: {[action.sessionId]: action.sessionActivity}})
      }

    case SET_SESSION_REQUESTS:
      // return state.mergeDeep({_requests: action.sessionRequests})
      return state.set('_requests', fromJS(action.sessionRequests))


    case SET_SESSION_REQUEST:
      // TODO: change it to {_requests:{expertUid:{...}}}
      // return state.mergeDeep({
      //   _requests: {[action.expertUid]: {[action.userUid]: action.sessionRequest}}
      // })
      return state.setIn(['_requests', action.expertUid, action.userUid], fromJS(action.sessionRequest))

    case SET_SESSION_CLAIMS:
      return state.set('claims', fromJS(action.claims || {}))

    default:
      return state
  }
}



/** WEBPACK FOOTER **
 ** ./modules/shared/data/reducers/sessions.js
 **/